// extracted by mini-css-extract-plugin
export var container = "NewsletterWidget-module--container--48d64";
export var footerContainer = "NewsletterWidget-module--footerContainer--8cb25";
export var form = "NewsletterWidget-module--form--bb3c7";
export var icon = "NewsletterWidget-module--icon--e8453";
export var message = "NewsletterWidget-module--message--6c035";